'use client';

import { useAuth } from '@/contexts/AuthContext';
import type { ReactNode } from 'react';

/**
 * LoggedOutOnly
 *
 * 目的:
 * - ログイン中はCTA（会員申込/今すぐ入会など）を非表示にする
 *
 * 引数:
 * - children: ログアウト時のみ表示する要素
 *
 * 戻り値:
 * - JSX.Element | null
 */
export default function LoggedOutOnly({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return null;
  return <>{children}</>;
}





